export default "__VITE_ASSET__C_$JchkG__"